var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDlFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.65 130.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 4px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M128.65,65.32c0,34.97-28.35,63.33-63.32,63.33S2,100.3,2,65.32,30.35,2,65.33,2s63.32,28.35,63.32,63.32Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.53,99.66h-13.77v-30.55s-9.61,0-9.61,0l-.14-12.62h9.75s-.18-8.91.14-12.05c.44-4.25,2.72-12.48,11.33-13.05,8.61-.57,15.2,0,15.2,0v12.33h-9.18s-3.44,0-3.73,2.87c-.29,2.87,0,10.04,0,10.04h10.9l-1.72,12.33-9.04.14-.14,30.55Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDlFb);
export default __webpack_public_path__ + "static/media/DL_FB.a3ddbbf0881157d29a5657c8f08847e8.svg";
export { ForwardRef as ReactComponent };